import { useState, useCallback } from 'react'

export const usePrescriptionSubmission = ({ apiClasses }) => {
    const [loading, setLoading] = useState(false)

    const submitPrescriptions = useCallback(async ({
        prescriptions,
    }) => {
        return prescriptions
    }, [])

    const completeConsultation = useCallback(async ({
        prescriptions,
        unTemplatizedPrescriptions,
        needsReview,
        pin,
        useTFA,
        providerOTPCode,
        patientExplanation,
        rejectionReason,
        chartingNote,
        caseId
    }) => {
        if (!apiClasses?.CasesApi) {
            throw new Error('CasesApi not available')
        }

        setLoading(true)
        try {
            const response = await apiClasses.CasesApi.completeConsultation(caseId, {
                prescriptions,
                unTemplatizedPrescriptions,
                needsReview,
                pin,
                useTFA,
                providerOTPCode,
                patientExplanation,
                rejectionReason,
                chartingNote,
            })

            return response
        } catch (error) {
            throw error.response?.data?.message || error.message || 'An unexpected error occurred'
        } finally {
            setLoading(false)
        }
    }, [apiClasses])

    return {
        loading,
        submitPrescriptions,
        completeConsultation
    }
}



